var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPoison = function SvgPoison(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4EEF3",
    d: "M28.333 4.917c12.565 0 22.75 10.185 22.75 22.75 0 12.566-10.185 22.75-22.75 22.75s-22.75-10.184-22.75-22.75c0-12.565 10.185-22.75 22.75-22.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F6",
    d: "M21.298 17.833h2.292v-4.778h8.785v4.778h2.292c2.94 0 5.32 2.38 5.32 5.32v24.972H15.995V23.153c0-2.94 2.38-5.32 5.32-5.32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E7EB",
    d: "M34.703 17.833H32.41v-4.778h-4.392v35.07h12.005V23.153c0-2.94-2.38-5.32-5.32-5.32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M22.768 7.875h10.465l-.84 5.18h-8.785z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M28 7.875v5.18h4.392l.84-5.18z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E7EB",
    d: "M21.105 11.883h13.808v2.38H21.105z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M40.005 25.025S35.577 21.35 28 24.185c-7.578 2.853-12.005-1.05-12.005-1.05v24.973h24.01z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00484E",
    d: "M28 24.185v23.94h12.005v-23.1S35.577 21.35 28 24.185"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.615 43.015h-13.23v-13.23h13.23z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F6",
    d: "M28 29.803h6.615v13.23H28z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M20.195 28.613v15.592h15.593V28.613zm13.23 13.23h-10.85v-10.85h10.85z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "m31.518 34.563-1.68-1.68L28 34.72l-1.837-1.837-1.68 1.68L26.32 36.4l-1.837 1.837 1.68 1.68L28 38.08l1.837 1.837 1.68-1.68L29.68 36.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M23.17 20.3h2.38v2.433h-2.38zM26.81 16.503h2.38v2.432h-2.38zM28 11.883h6.895v2.38H28z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#00484E",
    d: "M28 16.503h1.19v2.432H28z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "M28 28.613v2.38h5.425v10.85H28v2.38h7.805V28.63H28z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "m31.518 34.563-1.68-1.68L28 34.72v3.36l1.837 1.837 1.68-1.68L29.68 36.4z"
  })));
};
export default SvgPoison;